import InputMultiSelect from '../../InputMultiSelect/InputMultiSelect'
import connectFormikField from '../connectFormikField/connectFormikField'

const FormikMultiSelect = connectFormikField(InputMultiSelect)

export default FormikMultiSelect
